// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"Login_mainContainer__2k-W1","main":"Login_main__32lJp","formContainer":"Login_formContainer__3eo0Q","form":"Login_form__2Nv0s"};